'use strict';

exports.distance = require('./distances');
exports.similarity = require('./similarities');